import DataLayerService from "./datalayer";

export default DataLayerService;
export * as types from "./types";
